import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { inr } from "@/lib/api";

export const PartySales = ({ partySales }) => {
  if (!partySales) return <div className="h-72 bg-[#1E293B] border border-[#334155] rounded-lg animate-pulse" />;
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div data-testid="party-sales-chart" className="bg-[#1E293B] border border-[#334155] rounded-lg p-5">
        <h3 className="text-lg font-semibold mb-4" style={{ fontFamily: "Outfit, sans-serif" }}>Party-wise Sales <span className="text-sm text-slate-400 font-normal">(units)</span></h3>
        <ResponsiveContainer width="100%" height={Math.max(220, partySales.length * 36)}>
          <BarChart data={partySales} layout="vertical" margin={{ left: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#334155" horizontal={false} />
            <XAxis type="number" tick={{ fill: "#94A3B8", fontSize: 11 }} />
            <YAxis type="category" dataKey="party" width={150} tick={{ fill: "#94A3B8", fontSize: 11 }} />
            <Tooltip contentStyle={{ backgroundColor: "#111827", border: "1px solid #334155", borderRadius: 8, color: "#F8FAFC", fontSize: 12 }} cursor={{ fill: "#334155", opacity: 0.3 }} />
            <Bar dataKey="units" fill="#10B981" radius={[0, 4, 4, 0]} name="Units" />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div data-testid="party-sales-table" className="bg-[#1E293B] border border-[#334155] rounded-lg p-5 overflow-auto">
        <h3 className="text-lg font-semibold mb-4" style={{ fontFamily: "Outfit, sans-serif" }}>Party Breakdown</h3>
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-widest text-slate-400 border-b border-[#334155]">
              <th className="pb-2 pr-2">#</th><th className="pb-2 pr-2">Party</th>
              <th className="pb-2 pr-2 text-right">Units</th><th className="pb-2 text-right">Value</th>
            </tr>
          </thead>
          <tbody>
            {partySales.map((p, i) => (
              <tr key={p.party} data-testid={`party-row-${i}`} className="border-b border-slate-800/60 hover:bg-slate-800/40 transition-colors">
                <td className="py-2.5 pr-2 text-slate-500 font-mono text-xs">{i + 1}</td>
                <td className="py-2.5 pr-2 text-slate-200">{p.party}</td>
                <td className="py-2.5 pr-2 text-right font-mono">{p.units}</td>
                <td className="py-2.5 text-right font-mono text-emerald-400">{p.value > 0 ? inr(p.value) : "—"}</td>
              </tr>
            ))}
            <tr data-testid="party-total-row" className="border-t-2 border-slate-600 font-bold">
              <td className="py-2.5 pr-2"></td>
              <td className="py-2.5 pr-2 text-slate-100">TOTAL</td>
              <td className="py-2.5 pr-2 text-right font-mono text-slate-100">{partySales.reduce((t, p) => t + p.units, 0)}</td>
              <td className="py-2.5 text-right font-mono text-emerald-400">{partySales.reduce((t, p) => t + p.value, 0) > 0 ? inr(partySales.reduce((t, p) => t + p.value, 0)) : "—"}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
